import React, { createContext, useContext, ReactNode } from 'react';

interface SSRDataContextValue {
  initialData: any | null;
}

const SSRDataContext = createContext<SSRDataContextValue>({ initialData: null });

export const SSRDataProvider: React.FC<{ children: ReactNode; initialData: any | null }> = ({ children, initialData }) => {
  return (
    <SSRDataContext.Provider value={{ initialData }}>
      {children}
    </SSRDataContext.Provider>
  );
};

export const useSSRData = () => useContext(SSRDataContext);
